import { Injectable, inject } from '@angular/core';
import { SiaGridApi } from '../apis/sia-grid-api';
import { GridHttpParams } from '../interfaces/grid-http-params';
import { SiaGridPageRequest } from '../interfaces/sia-grid-page-request';
import { SiaGridPageResponse } from '../interfaces/sia-grid-page-response';
import {
  SiaGridSummary,
  SiaGridSummaryRequest,
} from '../interfaces/sia-grid-summary-request';
@Injectable({
  providedIn: 'root',
})
export class SiaGridService {
  private api = inject(SiaGridApi);

  loadData(params: SiaGridPageRequest): Promise<SiaGridPageResponse> {
    return this.api.loadData(params);
  }

  deleteRow(gridId: string, keysData: any) {
    return this.api.deleteRow(gridId, keysData);
  }

  massiveDelete(
    gridId: string,
    spName: string,
    keysData: any[],
  ): Promise<boolean> {
    return this.api.massiveDelete(gridId, spName, keysData);
  }

  updateRow(gridData: GridHttpParams): Promise<any> {
    return this.api.updateRow(gridData);
  }
  insertRow(gridData: GridHttpParams): Promise<any> {
    return this.api.insertRow(gridData);
  }

  loadSummary(params: SiaGridSummaryRequest): Promise<SiaGridSummary[]> {
    return this.api.loadSummary(params);
  }
  loadHeaderFilterData(params: SiaGridPageRequest): Promise<any> {
    return this.api.loadHeaderFilterData(params);
  }
}
